import { request } from "./request";

export default {
  /**
   * 客户联系人列表
   * @param {Number} CustomerId 
   */
  getCustomerContactsByCustomerId (CustomerId) {
    return request({
      url: "/Customer/getCustomerContacts",
      method: "get",
      params: {
        CustomerId
      }
    })
  },
    /**
   * 客户联系人列表
   * @param {object} CustomerId 
   */
     getCustomerContactsByCompanyId (data) {
      return request({
        url: "/Customer/getCustomerContactsByCompanyId",
        method: "get",
        params: data
      })
    }
}
